import { render } from "./Example7.vue?vue&type=template&id=27e92e26"
import script from "./Example7.vue?vue&type=script&lang=ts"
export * from "./Example7.vue?vue&type=script&lang=ts"
script.render = render

export default script